import React, { Component, createRef } from 'react';
import { Link } from 'react-router-dom';
import { formatWithOptions } from 'date-fns/fp';
import { th } from 'date-fns/locale';
import LoadingOverlay from 'react-loading-overlay';
import { osName } from 'react-device-detect';
import { connect } from 'react-redux';

import { alertActions, } from '../../actions';
import { commonConstant, CustomCheckbox } from '../../common';
import { customerService, activityService } from '../../services';
import { Modal, AWDatepicker } from '../../helpers';
import _ from 'lodash';
import {
  FIELD_TYPE,
  LABEL_ABO_DATE_OF_BIRTH_PLACEHOLDER,
  LABEL_ACCEPT_TNC,
  LABEL_ALERT_DUPLICATE_DESCRIPTION,
  LABEL_ALERT_NO_PHONE_DESCRIPTION,
  LABEL_ALERT_NO_PHONE_OK_BTN,
  LABEL_ALERT_NO_PHONE_TITLE,
  LABEL_MEMBER_ALERT_DUPLICATE_CANCEL_BTN,
  LABEL_MEMBER_ALERT_DUPLICATE_OK_BTN,
  LABEL_MEMBER_ALERT_DUPLICATE_TITLE,
  LABEL_MEMBER_ALERT_WRONG_INFO_DESCRIPTION,
  LABEL_MEMBER_ALERT_WRONG_INFO_OK_BTN,
  LABEL_MEMBER_ALERT_WRONG_INFO_TITLE,
  LABEL_MEMBER_TEXT_NOTICE,
  LABEL_REGISTRATION_ABO_SUBTITLE,
  LABEL_REGISTRATION_ABO_TITLE,
} from '../../common/commonConstant';
import HomeAlertModal from '../home/homeAlertModal/HomeAlertModal';
import { IdField } from '../home/components';
import StickyBottom from '../../common/stickyButtonFooter/StickyBottom';
import './member.scss';

const today = new Date();
const maxYear = today.getFullYear() + 540;
const minYear = today.getFullYear() + 443;

class Member extends Component {
  constructor(props) {
    super(props);

    const customer = JSON.parse(sessionStorage.getItem('customer'));
    if (sessionStorage.getItem('customer') === null || sessionStorage.getItem('customer') === 'undefined') {
      window.location.replace(commonConstant.pathHome);
    }

    this.state = {
      customer: customer,
      birthday: new Date(this.props.location?.state.birthday).getTime() ? this.props.location?.state.birthday : '',
      distNum: '',
      loading: false,
      error: false,
      isOpenCalendar: false,
      accept: this.props.location?.state.accept || false,
      isOpenModal: false,
      modalContent: 'notfound',
      profile: '',
      isPickerOpen: false,
      selectedPartyId: '',
    };
  }

  checkboxRef = createRef();

  componentDidMount() {
    const { location } = this.props;
    if (!location.state || !location.state.myMember || location.state.myMember.accountMst.accountTypeCd !== 'Member')
      return window.location.replace(commonConstant.pathHome);
    this.setState({ profile: location.state.myMember })
    this.checkboxRef.current.checked = this.state.accept;
  }

  onPaste = e => {
    e.preventDefault();
    return false;
  };

  handleCheckBox = () => {
    this.props.history.replace({
      state: {
        ...this.props.location.state,
        accept: !this.state.accept
      }
    });
    this.setState({ accept: !this.state.accept });
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value });
  handleDate = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleCloseDate = () => this.setState({ isOpenCalendar: false });
  handleOkDate = _day => {
    const birthday = `${_day.getDay()} / ${_day.getMonth()} / ${_day.getFullYear()}`;
    this.setState({ isOpenCalendar: false, birthday });
  };
  toggleModal = (content) => {
    this.setState({
      isOpenModal: !this.state.isOpenModal,
      modalContent: content,
    });
  }

  handleDobChange = (dob) => {
    this.setState({ birthday: dob, isPickerOpen: false });
  };

  handlePickerDelete = () => {
    this.setState({ birthday: '', isPickerOpen: false });
  };

  handleCheckValidDate = () => this.state?.birthday?.getTime();

  handleModalContent = () => {
    const { modalContent, profile } = this.state;
    switch (modalContent) {
      case 'duplicate':
        return {
          title: LABEL_MEMBER_ALERT_DUPLICATE_TITLE, detail: LABEL_ALERT_DUPLICATE_DESCRIPTION(this.state?.oldMember?.displayName),
          btnText: LABEL_MEMBER_ALERT_DUPLICATE_OK_BTN, cancelBtnText: LABEL_MEMBER_ALERT_DUPLICATE_CANCEL_BTN
        };
      case 'wrongBirthDay':
      case 'invalidbd':
        return {
          title: LABEL_MEMBER_ALERT_WRONG_INFO_TITLE, detail: LABEL_MEMBER_ALERT_WRONG_INFO_DESCRIPTION,
          btnText: LABEL_MEMBER_ALERT_WRONG_INFO_OK_BTN
        }
      case 'phoneNotFound':
        return {
          title: LABEL_ALERT_NO_PHONE_TITLE, detail: LABEL_ALERT_NO_PHONE_DESCRIPTION,
          btnText: LABEL_ALERT_NO_PHONE_OK_BTN, btnCss: 'p-lr-40'
        }
      default:
        break;
    }
  }
  getNameFromPartyId = (profile, partyId) => {
    if (!profile || !Array.isArray(profile.partyList)) {
      return '';
    }
  
    const party = profile.partyList.find(
      (p) => String(p?.partyMst?.partyId) === String(partyId)
    );
  

    if (!party) return '';
  

    if (party.partyMst?.partyTypeCd !== 'Person') {
      return '';
    }
  
  
    if (Array.isArray(party.nameList) && party.nameList[0]?.localeName) {
      const { title, givenName, familyName } = party.nameList[0].localeName;
      const fullName = [title, givenName, familyName]
        .filter(Boolean)
        .join(' ')
        .trim();
  
      if (fullName) return fullName;
    }
  
  
    if (Array.isArray(party.nameList) && party.nameList[0]?.latinName) {
      const { title, givenName, familyName } = party.nameList[0].latinName;
      const fullName = [title, givenName, familyName]
        .filter(Boolean)
        .join(' ')
        .trim();
  
      if (fullName) return fullName;
    }
  

    return '';
  };

  handleSubmit = async e => {
    window.scrollTo(0, 1);
    const { profile } = this.state;
    const amwayNumber = profile.accountMst.aboNum;
    const { location } = this.props;

    e.preventDefault();
    this.setState({
      loading: true,
    });

    if (!this.handleCheckValidDate()) {
      this.toggleModal('invalidbd');
      this.setState({ loading: false });
      return false;
    }

    const date = this.state.birthday;
    const dateString = `${date.getFullYear()}-${(date.getMonth() + 1 + '').padStart(2, '0')}-${(date.getDate() + '').padStart(2, '0')}`;
    const searchKey = amwayNumber + dateString;
    let userBirthDate = null;
    let inputBirthDate = '';
    let userGender = '';
    let phoneList;

    let findIndex = profile.partyList.findIndex(party => {
      return party.partyMst.birthdate.substr(0, 10) === dateString;
    });

    if (findIndex !== -1) {

      inputBirthDate = dateString;
      userBirthDate = profile.partyList[findIndex].partyMst.birthdate.substr(0, 10);
      userGender = profile.partyList[findIndex].partyMst.genderCd || '';

      console.log('test', findIndex);
      console.log("userBirthDate", userBirthDate);
      console.log('inputBirthDate', inputBirthDate);
    } else {

      this.setState({ isOpenModal: false, loading: false });
      this.toggleModal('wrongBirthDay');
      return
    }

    console.log('profile.partyList[findIndex].partyMst////', profile.partyList[findIndex].partyMst.partyId
    );

    let partyId2 = profile.partyList[findIndex].partyMst.partyId
    this.setState({ selectedPartyId: partyId2 });
    console.log('partyId2', partyId2);

    // if (getBirthDate[0] && getBirthDate[0].birthdate) {

    //   inputBirthDate = date.toISOString().substr(0, 10);
    //   userBirthDate = getBirthDate[0].birthdate.substr(0, 10);

    //   console.log('inputBirthDate', inputBirthDate);

    //   console.log('userBirthDate', userBirthDate);
    // }

    // if (inputBirthDate !== userBirthDate) {
    //   this.setState({ isOpenModal: false, loading: false });
    //   this.toggleModal('wrongBirtDay');
    //   return;
    // }

    let cidKey = searchKey;
    if (profile && findIndex !== -1) {
      // const cleanData = _.filter(profile.partyList, function (o) { return o.taxList[0] && o.taxList[0].taxTypeCd === 'CID' && o.partyMst && o.partyMst.roleCd === 'BusinessOwner'; });
      // const last4Digit = cleanData.map(function (raw) {
      //   return raw.taxList[0].taxId;
      // });
      // cidKey = last4Digit ? last4Digit[0] : searchKey;
      cidKey = profile.partyList[findIndex].taxList.length ? profile.partyList[findIndex].taxList[0].taxId : cidKey;
    }

    if (location?.state?.myMember && findIndex !== -1) {
      phoneList = location?.state?.myMember?.partyList?.length && location?.state?.myMember?.partyList[findIndex].phoneList?.length
        && location?.state?.myMember?.partyList[findIndex].phoneList.find((list) => list?.phoneLocalNum?.trim() !== '' && list?.contactPointTypeCd === 'Mobile' && Array.isArray(list?.usageList) && list?.usageList.find((usage) => usage?.primaryFlag));
    }

    const myMember = await customerService.findMemberByPartyId(amwayNumber, partyId2);
    console.log('myMember: ', myMember);
    if (myMember && (myMember.uid !== this.state.customer.uid) && myMember.partyId == partyId2) {
      if (!phoneList) {
        this.setState({ isOpenModal: false, loading: false });
        this.toggleModal('phoneNotFound');
        return;
      }
      this.setState({ isOpenModal: false, loading: false, oldLineId: myMember.uid, oldMember: myMember });
      this.toggleModal('duplicate');
      return false;
    }

    const ABOname =
      this.getNameFromPartyId(profile, partyId2) ||
      profile.accountMst.accountLocalName ||
      profile.accountMst.accountName ||
      '';

    const customer = {
      ...this.state.customer,
      name: ABOname,
      _id: this.state.customer._id,
      amwayNumber: parseInt(amwayNumber),
      birthday: dateString,
      gender: userGender.toLowerCase(),
      // partyId: profile.accountMst.primaryPersonPartyId,
      partyId: partyId2,
      socialType: 'LINE',
      ...(phoneList ? { phone: phoneList.phoneLocalNum } : null)
    };
    console.log('customer', customer);
    console.log('partyId2', partyId2);

    sessionStorage.setItem('customer', JSON.stringify(customer));

        // activityService.create({
        //   uid: this.state.customer.uid,
        //   userId: this.state.customer._id,
        //   status: 'incomplete',
        //   action: 'SELECT_PRODUCT',
        // });

        // const params = {
        //   registerStatus: 'incomplete',
        //   action: 'SELECT_PRODUCT',
        // };

        // customerService.update(this.state.customer._id, params);

      //return this.props.history.push('/interest');const { location } = this.props;

      if (!phoneList) {
        this.setState({ isOpenModal: false, loading: false });
        this.toggleModal('phoneNotFound');
        return;

    }

      return this.props.history.push(commonConstant.pathVerifyOtp, {
        myMember: this.props.location.state.myMember,
        user: customer,
        phoneList,
        detailType: 'member'
      });

  }

  handleModalOk = async () => {
    const { modalContent, isOpenModal } = this.state;
    this.setState({ isOpenModal: !isOpenModal });
    if (modalContent === 'duplicate') {
      this.setState({ isOpenModal: !isOpenModal });
      // return window.location = '/otp';
      return this.props.history.push('/changeMID', { myMember: this.props.location.state.myMember, oldLineId: this.state.oldLineId, oldMember: this.state.oldMember, partyId: this.state.selectedPartyId })
    } else if (['invalidbd', 'notfound', 'wrongBirthDay'].includes(modalContent)) {
      this.props.history.replace({
        state: {
          ...this.props.location.state,
          accept: !this.state.accept
        }
      });
      this.setState({ isOpenModal: !isOpenModal, accept: false, birthday: '' });
      this.checkboxRef.current.checked = false;
    } else {
      this.setState({ isOpenModal: !isOpenModal });
      return window.location = 'tel:027258000';
    }
  }

  render() {
    const { birthday, accept, isOpenModal, modalContent, profile } = this.state;
    const isTrue = birthday && accept ? true : false;
    const { location } = this.props;

    const content = this.handleModalContent();
    return (
      <div className="member">
        <LoadingOverlay active={this.state.loading} spinner text="Loading" styles={{ wrapper: { width: '100%', minHeight: '100%' } }} />
        {isOpenModal &&
          <HomeAlertModal
              title={content.title}
            description={content.detail}
            btnFn={this.handleModalOk}
            cancelBtnFn={this.toggleModal}
            isOpen={isOpenModal}
            onClose={this.toggleModal}
            cancelBtnText={content.cancelBtnText}
            btnText={content.btnText}
            btnCss={content?.btnCss} />
        }

        <form className="registration-form" onSubmit={this.handleSubmit}>
          <div className="logoAmway">
            <img src="/images/registration/AmwayLineBusinessConnectLogo.png" alt="" />
          </div>
          <div className="title">{LABEL_REGISTRATION_ABO_TITLE}</div>
          <div className="subtitle">{LABEL_REGISTRATION_ABO_SUBTITLE}</div>
          <div className="amwayNumber">{profile && profile.accountMst.aboNum}</div>

          <div className="cid-form">
            <IdField
              heading="วันเกิด"
              placeholder={LABEL_ABO_DATE_OF_BIRTH_PLACEHOLDER}
              type={FIELD_TYPE.Date}
              value={birthday && formatWithOptions({ locale: th }, 'd MMMM yyyy')(birthday)}
              onDateSubmit={this.handleDobChange}
              onDateDelete={this.handlePickerDelete}
              isPickerOpen={this.state.isPickerOpen}
              preIconPath='/images/common/CalendarIcon.png'
              preIconDisabledPath='/images/common/CalendarIconDisabled.png' />
            </div>
          <div className="member-text-notice">{LABEL_MEMBER_TEXT_NOTICE}</div>

          <StickyBottom buttonProps={{ type: 'submit' }} buttonText="ถัดไป" isActive={isTrue}>
            <div className="home-registration-tnc-wrapper">
              <CustomCheckbox onChange={this.handleCheckBox} accept={accept} ref={this.checkboxRef} />
              <div className="home-registration-tnc-link">
                <Link className="" to={{
                  pathname: '/condition',
                  state: { from: location, birthday, accept },
                }}>{LABEL_ACCEPT_TNC}</Link>
            </div>
          </div>
          </StickyBottom>
        </form>
      </div >
    );
  }
}

function mapDispatchToProps(dispatch) {
  return ({
    showError: (message) => dispatch(alertActions.showError(message)),
  });
}

export default connect(null, mapDispatchToProps)(Member);
